export const CONNECT_TIMEOUT_MS = 30000;

// timeoutMs is read when a connect starts so tests can shorten the deadline.
// afterAttemptAdvance runs after the attempt ref moves and before signIn schedules updates,
// which is the window where a stale connect can still see cancelled === false.
export const connectTiming = {
    timeoutMs: CONNECT_TIMEOUT_MS,
    afterAttemptAdvance: null as null | (() => void),
};
